import { dayjs } from '@convenia/utils'
import { cellphoneValidation, formatDateToString, calculateAge, cpf as cpfValidator } from '@convenia/helpers'
import { fullNameValidation, fullNameValidationMsg } from '@convenia/employee-organisms/SystemFields/helpers'

const isAdult = (birthDate) => {
  const date = formatDateToString(birthDate)

  return !!date && calculateAge(new Date(date)) >= 18
}

export default () => ({
  fullName: {
    type: 'text',
    label: 'Nome completo',
    placeholder: 'Nome completo',
    required: true,
    validation: {
      required: true,
      custom: fullNameValidation
    },
    validationMsg: fullNameValidationMsg,
    value: '',
  },

  relationshipId: {
    type: 'select',
    label: 'Relação',
    placeholder: 'Relação',
    value: '',
    displayBy: 'name',
    trackBy: 'id',
    nullable: true,
  },

  birthDate: {
    type: 'date',
    label: 'Data de nascimento',
    placeholder: 'Data de nascimento',
    enableInput: true,
    maxDate: dayjs().toDate(),
    validation: {
      custom: (_, input) => dayjs(input).isValid() && dayjs(input).isSameOrBefore(dayjs().toDate())
    },
    validationMsg: 'A data de nascimento não pode ser futura.',
  },

  genderId: {
    type: 'select',
    label: 'Gênero no documento',
    displayBy: 'name',
    trackBy: 'id',
    nullable: true,
  },

  educationTypeId: {
    type: 'select',
    label: 'Escolaridade',
    placeholder: 'Escolaridade',
    nullable: true,
    displayBy: 'name',
    trackBy: 'id',
  },

  cpf: {
    type: 'text',
    label: 'CPF de dependente',
    mask: '###.###.###-##',
    inputmode: 'numeric',
    placeholder: 'CPF de dependente',
    skipIfEmpty: false,
    emitPreValidation: true,
    hint: 'Este campo é obrigatório para maiores de 18 anos que não sejam estrangeiros.',
    validation: {
      custom: ({ value, formValue = {} } = {}) => {
        const birthDateValue = formValue.birth_date || formValue.birthDate
        const isCpfRequired = isAdult(birthDateValue) && !formValue.foreigner

        if (isCpfRequired && !value) return 'Para dependentes com 18 anos ou mais, o CPF é obrigatório.'

        return cpfValidator.validate(value) || 'CPF inválido. Confira os números digitados.'
      }
    },
    value: ''
  },

  phone: {
    type: 'text',
    label: 'Contato',
    placeholder: 'Contato',
    inputmode: 'numeric',
    mask: [ '(##) ####-####', '(##) #####-####' ],
    validationMsg: 'Número inválido',
    validation: { custom: (_, value) => cellphoneValidation(value) },
    value: ''
  },

  email: {
    type: 'text',
    label: 'E-mail',
    placeholder: 'E-mail',
    validation: {
      max: 106,
      email: true
    },
    value: ''
  },

  hasWorkDisability: {
    type: 'radio',
    label: 'Dependente possui incapacidade física ou mental para trabalho?',
    value: false,
    displayBy: 'label',
    trackBy: 'value',
    options: [
      { label: 'Sim', value: true },
      { label: 'Não', value: false }
    ]
  },

  motherName: {
    type: 'text',
    label: 'Nome completo da mãe',
    placeholder: 'Nome completo da mãe',
    validation: { custom: fullNameValidation },
    validationMsg: fullNameValidationMsg,
    value: ''
  },

  description: {
    type: 'text',
    textArea: true,
    maxLength: 220,
    rows: 2,
    label: 'Observações',
    placeholder: 'Observações',
    validation: { max: 220 },
    value: ''
  },

  ir: {
    type: 'check',
    label: 'Incluir para fins de <b>imposto de renda.</b>',
    value: false,
  },

  familySalary: {
    type: 'check',
    label: 'Salário família',
    value: false,
  },

  foreigner: {
    type: 'check',
    label: 'Estrangeiro',
    value: false,
  },

  documentFiles: {
    type: 'file',
    label: '',
    showLabel: false,
    multiple: true,
    labelLeft: false,
    fullWidth: true,
    extensions: [ 'jpg', 'jpeg', 'gif', 'bmp', 'png', 'pdf' ],
    fileLimit: 4,
    validation: { maxLength: 4 },
    sizeLimit: 8,
  }
})
